(function () {
  "use strict";

  a3_cabin_reports.factory(
    "GroomingCategoriesFactory",
    GroomingCategoriesFactory,
  );
  /**
   * @memberof CabinReports
   * @ngdoc factory
   * @name GroomingCategoriesFactory
   * @description
   * Get grooming categories
   * @ngInject
   */
  function GroomingCategoriesFactory($http, apiUrl, GenericService) {
    var groomingReportsByCrew = {};
    var service = {
      setGroomingCategories: setGroomingCategories,
      getGroomingCategories: getGroomingCategories,
      collectGroomingReports: collectGroomingReports,
      saveGroomingReports: saveGroomingReports,
      loadGroomingReports: loadGroomingReports,
      clearGroomingReportsFromStorage: clearGroomingReportsFromStorage,
    };

    /**
     * Initialize the GroomingCategory
     * @memberof GroomingCategoriesFactory
     */
    function GroomingCategory() {
      this.Id = null;
      this.Label = null;
      this.Description = null;
      this.OrderNo = null;
      this.Active = false;
    }
    var objEventType = "groomingCategories";
    var objCallback = GroomingCategory;

    /**
     * Save grooming categories
     * @memberof GroomingCategoriesFactory
     * @param {Array} GroomingCategories
     */
    function setGroomingCategories(groomingCategories) {
      GenericService.saveAll(groomingCategories, objEventType);
    }

    /**
     * Get Event Types
     * @memberof FlightServiceEventsFactory
     * @returns {Array} EventTypes
     */
    function getGroomingCategories() {
      return GenericService.list(objEventType, objCallback);
    }

    function collectGroomingReports(groomingReportsByCrew) {
      var groomingReports = [];

      if (groomingReportsByCrew) {
        for (var crewId in groomingReportsByCrew) {
          var crewReports = groomingReportsByCrew[crewId];
          crewReports.forEach((category) => {
            if (category.UserInput && category.UserInput.trim() !== "") {
              groomingReports.push({
                crewId: crewId,
                groomingCategoryId: category.Id,
                feedback: category.UserInput.trim(),
              });
            }
          });
        }
      }
      return groomingReports;
    }

    function saveGroomingReports(groomingReports) {
      localStorage.setItem("groomingReports", JSON.stringify(groomingReports));
    }

    function loadGroomingReports() {
      try {
        var raw = localStorage.getItem("groomingReports");
        if (!raw) return {};
        return JSON.parse(raw) || {};
      } catch (e) {
        return {};
      }
    }

    function clearGroomingReportsFromStorage() {
      localStorage.removeItem("groomingReports");
    }

    return service;
  }
})();
